module.exports = __webpack_public_path__ + "static/media/undraw_chore_list_iof3.a55edfb2.png";